module.exports = [
    {
        id: 'Default',
        content: require('./default-header.html').trim(),
    },
    {
        id: 'Jamie_Oliver',
        content: require('./jamie-oliver-header.html').trim(),
    },
];



// WEBPACK FOOTER //
// ./src/recipe/detail-templates/index.js